<div class="grid-container margin-top">
  @if (template) {
    <div class="grid-x grid-margin-x">
      <div class="cell medium-2 text-align-right">
        <label for="id"> Id:  </label>
      </div>
      <div class="medium-10 padding-left">
        <input id="id" type="text" [(ngModel)]="template.id" />
      </div>
      <div class="cell medium-12">
        Content: <span class="italic">Content to be transformed by rule when generated should be in brackets</span> '[]'.
      </div>
      <div class="cell medium-12">
        <text-editor (formBuilt)="contentFormBuilt($event)" [froalaOptions]="editorOptions" [content]="template?.content"></text-editor>
      </div>
      <!--<div class="cell medium-12">
      <textarea cols="40" rows="20" [(ngModel)]="template.content" (keyup.enter)="templateContentChanged()" (blur)="templateContentChanged()" required>
      </textarea>
    </div>-->
    <div class="cell medium-12 margin-top">
      <table>
        <caption>Text Template Transforms</caption>
        <tr>
          <th>Replace</th>
          <th>Rule</th>
        </tr>
        @for (t of template.transforms; track t) {
          <tr>
            <td>
              {{t.name}}
            </td>
            <td>
              <textarea cols="20" rows="5" [(ngModel)]="t.expression">
              </textarea>
            </td>
          </tr>
        }
      </table>
    </div>
    <div class="cell medium-12">
      <button class="button" (click)="save()">Save</button>
    </div>
  </div>
} @else {
  @if (!template) {
    <p>No template loaded</p>
  }
}
</div>

